import { isEmpty } from "lodash";
import React, { useContext, useMemo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AuthProvider from "../context/AuthContext";


import { IoSearchSharp } from "react-icons/io5";

function Chat() {
  let {  chatToogle, setChatToogle, setProfileData, user } =
    useContext(AuthProvider);
  
  return (
    <>
      <div
        className="overlay right-side"
        id="settingDiv"
        style={{ display: chatToogle ? "block" : "none" }}
      >
        <div className="side-wrap setting-wrap chat-wrap" id="settingSlide">
        
          <div class="body sections faq-body ">
    <div class="dummy-bar gradient " ></div>
    <div class="card-layout scroll-section">
    <div className="side-head">
            {/* <h3 className="a-setting">
              <img
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt={""}
              />
              Setting
            </h3> */}
            <div class="h-header gradient">
    <div class="title fadeIn ">
      <div class="logo">
          <img class="animated zoomIn faster"  src={require("../assets/images/skyfiar-bottom.png")} alt="Widget logo"/>
      </div>
  </div>
  </div>
            <a
              className="close ui-link"
              onClick={() => setChatToogle(false)}
              href="javascript:void(0)"
              id="settingClose"
            ></a>
          </div>
      <div class="channel-section animated fadeInUp delay faster h-categories">
  <div class="channel-title">
    <div class="list-sub-title" role="heading" aria-level="1">
      Chat with us
    </div>
  </div>
  
      <ul class="channel-list">
            <li>
              <div id="ember55" class="channel animated fadeInLeft ember-view"><a href="/home/788618" id="ember56" class="ember-view channel-link">
  <div class="h-category-item">
    <div class="h-category-icon">
        <img class="img-circle avatar-image"  src={require("../assets/images/skyfiar-bottom.png")} alt="Channel icon"/>
    </div>
   <div class="channel-names ">
      <div class="channel-content">
        <div class="h-category-detail aw">
          <h2 class="channel-name  ">
            lc247
          </h2>
            <div class="welcome-text unreadMessage">
              <div class="message-text">
                  <div class="last-msg-preview ">
                    <div id="ember57" class="ember-view">  <div class="h-comment    ">

      <div id="ember58" class="fc-ui-unity-message-bubble ember-view">  <div class="h-message-text "><b>🏏 Champions Trophy is BACK! 🔥
        {/* <br/>After 8 years, the ICC Champions Trophy returns! 🏆
        <br/>💰Win big with Clash Trophy Cashback! Get 7% cashback up to ₹3,650 daily on cricket bets until March 9.<br/> */}
        </b>
        </div>
</div>
 
  </div>
</div>
                  </div>
              </div>
            </div>
        </div>
          <div class="h-conv-user">
              <div class="time-stamp">
                6:47 PM
              </div>
                <div class="h-notify " aria-label="2 unread messages">
                  <span aria-hidden="true">
                      2
                  </span>
                </div>
          </div>
      </div>
    </div>
  </div>
</a></div>
              <div class="border-bottom"></div>
            </li>
      </ul>
   </div>

          <div class="faq-list animated fadeInUp delay faster show-more">
    <div class="faq-header">
      <div class="title-header">
        <div class="list-sub-title" role="heading" aria-level="1">
            FAQs
        </div>
      </div>
      <div class="search-category" role="button" tabindex="0" aria-label="Search Frequently Asked Questions" data-ember-action="" data-ember-action-61="61">
       <IoSearchSharp/>
      </div>
    </div>
    <div class="faq-categories">
      <ul class="categories-list">
          <li tabindex="0" data-ember-action="" data-ember-action-62="62">
            <div class="category-item">
              <div class="category-icon">
                  <img  src={require("../assets/images/skyfiar-bottom.png")} class="img-circle avatar-image" alt="Category icon"/>
              </div>
              <div class="category-name">
                <div class="faq-title" role="heading" aria-level="2">
                  Contact Us
                </div>
              </div>

           </div>
            <div class="border-bottom"></div>
          </li>
          <li tabindex="0" data-ember-action="" data-ember-action-63="63">
            <div class="category-item">
              <div class="category-icon">
                  <img  src={require("../assets/images/skyfiar-bottom.png")} class="img-circle avatar-image" alt="Category icon"/>
              </div>
              <div class="category-name">
                <div class="faq-title" role="heading" aria-level="2">
                  Product Tours
                </div>
              </div>

          </div>
            <div class="border-bottom"></div>
          </li>
          <li tabindex="0" data-ember-action="" data-ember-action-64="64">
            <div class="category-item">
              <div class="category-icon">
                  <img  src={require("../assets/images/skyfiar-bottom.png")} class="img-circle avatar-image" alt="Category icon"/>
              </div>
              <div class="category-name">
                <div class="faq-title" role="heading" aria-level="2">
                  Deposits
                </div>
              </div>

        </div>
            <div class="border-bottom"></div>
          </li>
      </ul>
        <div class="see_more_faqs" role="button" tabindex="0" data-ember-action="" data-ember-action-65="65">
          Show more categories
        </div>
    </div>
  </div>


      <div class="bottom-gradient" ></div>
    </div>
  </div>
        </div>
      </div>
    </>
  );
}

export default Chat;
